import { z } from "zod"
import { zScenarioUpdate } from "./scenario.store"
import { NamedEntitySchema } from "@/lib/schemas"
import { createStaticStore, StaticStore } from "@/lib/store-factory"
import { endpoints } from "@/config/endpoints.config"

// ███████╗ ██████╗██╗  ██╗███████╗███╗   ███╗ █████╗
// ██╔════╝██╔════╝██║  ██║██╔════╝████╗ ████║██╔══██╗
// ███████╗██║     ███████║█████╗  ██╔████╔██║███████║
// ╚════██║██║     ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══██║
// ███████║╚██████╗██║  ██║███████╗██║ ╚═╝ ██║██║  ██║
// ╚══════╝ ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚═╝  ╚═╝
//

export const TemplateSchema = NamedEntitySchema.extend({
  description: z.string(),
  image_src: z.string(),
  categories: z.array(z.enum(["basic", "automation", "featured", "new", "support", "customer-service"])),
  long_description: z.string(),
  initialValues: zScenarioUpdate,
})

export type Template = z.infer<typeof TemplateSchema>

// ███████╗████████╗ ██████╗ ██████╗ ███████╗
// ██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗██╔════╝
// ███████╗   ██║   ██║   ██║██████╔╝█████╗
// ╚════██║   ██║   ██║   ██║██╔══██╗██╔══╝
// ███████║   ██║   ╚██████╔╝██║  ██║███████╗
// ╚══════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝
//
export interface TemplateStore extends StaticStore<Template> { }

export const templateStore: TemplateStore = createStaticStore<Template>({
  endpoint: endpoints.TEMPLATES,
})
